import { useTranslation } from "react-i18next";

interface BillAmountSummaryProps {
  /** Сборът на редовете — с отстъпките им по ред, без тази на сметката. */
  rowsTotal: number;
  amount: number;
  isEmpty: boolean;
}

/** Тялото на „На цялата сметка": Сметка → Отстъпка → За плащане, като
 *  обобщенията в „Закрий", и под тях как излиза на бона. */
export const BillAmountSummary = ({
  rowsTotal,
  amount,
  isEmpty,
}: BillAmountSummaryProps) => {
  const { t } = useTranslation();
  if (isEmpty) {
    return (
      <p className="m-0 py-6 text-center text-sm text-pos-muted">
        {t("itemDiscounts.emptyBill")}
      </p>
    );
  }
  const hasDiscount = amount >= 0.005;
  return (
    <div className="flex flex-col gap-2.5">
      <div className="rounded-[12px] border border-pos-line3 bg-pos-panel">
        <SummaryLine label={t("itemDiscounts.billRowsTotal")} value={rowsTotal.toFixed(2)} />
        <SummaryLine
          label={t("itemDiscounts.billTitle")}
          value={hasDiscount ? `−${amount.toFixed(2)}` : "0.00"}
          accent={hasDiscount}
        />
        <div className="flex items-baseline justify-between gap-3 border-t border-pos-line2 px-3.5 py-3">
          <span className="text-[14px] font-bold text-pos-ink">
            {t("itemDiscounts.billToPay")}
          </span>
          <span className="font-pos-mono text-[18px] font-bold tabular-nums text-pos-ink">
            {(rowsTotal - amount).toFixed(2)} €
          </span>
        </div>
      </div>
      <p className="m-0 text-[12px] font-medium leading-[1.4] text-pos-muted">
        {t("itemDiscounts.billReceiptNote")}
      </p>
    </div>
  );
};

const SummaryLine = ({
  label,
  value,
  muted,
  accent,
}: {
  label: string;
  value: string;
  muted?: boolean;
  accent?: boolean;
}) => (
  <div className="flex items-baseline justify-between gap-3 px-3.5 py-2.5">
    <span
      className={`text-[13.5px] font-semibold ${muted ? "text-pos-muted" : "text-pos-soft2"}`}
    >
      {label}
    </span>
    <span
      className={`font-pos-mono text-[14px] font-bold tabular-nums ${
        accent ? "text-pos-disc-ink" : muted ? "text-pos-muted" : "text-pos-ink"
      }`}
    >
      {value}
    </span>
  </div>
);
